import ReadMore from "./ReadMore";
import pic3 from "../img/pencil-case.png";
import pic4 from "../img/coding.png";
import pic5 from "../img/graphic-design.png";
import "./Services.css"


const Cards = () => {
    const cardInfo = [
        {
            img: pic5,
            title: "В той же день",
            text: " Наш повний спектр послуг занадто широкий, щоб перелічувати його тут, але серед деяких речей, які ми пропонуємо як послуги в той же день, є: портфоліо, журнали, листівки, брошури, буклети, бланки та канцелярські товари, візитні картки, палітурка книг, палітурка на замовлення, архітектурна документація  Друк, сухий монтаж, ламінування, банерні стенди та виставкова графіка, буклети, широкоформатний друк, палітурка дисертацій, сканування, листівки, листівки, шпалери та фрески, ацетатні відбитки, віконна графіка та вінілові написи, відбитки на флуоресцентному папері, друк фотографій, подарунки та інше."
        },
        {
            img: pic3,
            title: "Друк",
            text: "Друк на футболках, одязі та робочому одязі, відбитки білими чорнилами, кольорове фольгування, друк із насінням, висікання, наклейки та упаковка."
        },
        {   img: pic4,
            title: "Розсилка",
            text: " Також надаємо повний комплекс послуг з розсилки.  Підвищте свою маркетингову стратегію та рентабельність інвестицій за допомогою наскрізної керованої кампанії прямої розсилки від Sova. Ми можемо націлюватися на конкретні області чи аудиторії за допомогою персоналізованих кампаній, які забезпечують вимірювані та відстежувані результати. Це економічно ефективний метод, який знову і знову витримує випробування часом."
        },
    ];

    const renderCard = (card, index) => {
        return (
            <div key={index} className="box">
                <div className="title-card">
                    <h3>{card.title}</h3>
                    <div className="card-img">
                        <img src={card.img} alt="img"/>
                    </div>
                </div>
                <ReadMore limit={60}>{card.text}</ReadMore>
            </div>
        );
    };

    return <div className="card-items">{cardInfo.map(renderCard)}</div>;
};

export default Cards;

